import React, { useState, useRef, useEffect } from 'react';
import {
    Button, Tooltip, TextField, Typography, IconButton,
    Dialog, DialogActions, DialogContent, DialogTitle
} from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import axios from 'axios';

function RenaiEventCommitment({ data, enabled, onSubmitCommitment }) {
    const [commitment, setCommitment] = useState(data);
    const [modalOpen, setModalOpen] = useState(false);

    const onClick = () => {
        setModalOpen(true);
    };

    const onClose = () => {
        setModalOpen(false);
    };

    const onSubmit = (content) => {
        onSubmitCommitment?.(content);
    };

    useEffect(() => {
        setCommitment(data);
    }, [data]);

    return <>
        <Button variant="contained" color="primary" disabled={!enabled} onClick={onClick}>{!commitment ? 'Submit AI Commitment' : 'Review commitment'}</Button>
        <RenaiEventCommitmentForm isOpen={modalOpen} onClose={onClose} onSubmit={onSubmit} commitment={commitment} />
    </>;
}

function RenaiEventCommitmentForm({ isOpen, onClose, onSubmit, commitment }) {
    const textarea = useRef(null);
    const [error, setError] = useState(null);
    const [editing, setEditing] = useState(!commitment);

    useEffect(() => {
        setEditing(!commitment);
    }, [commitment]);

    const handleSubmit = () => {
        setError(null);
        axios.post("api/pageattendances/completion", { reflection: textarea.current.value }, { withCredentials: true })
            .then(() => {
                onSubmit?.(textarea.current.value);
            })
            .catch(e => {
                setError(e.response.data.errors.reflection);
            });
    };

    return <Dialog open={isOpen} onClose={onClose} aria-labelledby={"renai-commitment-dialog-title"} maxWidth={'md'} fullWidth>
        <DialogTitle aria-labelledby={"renai-commitment-dialog-title"}>Commitment</DialogTitle>
        <DialogContent>
            {editing ? <><Typography variant="body1">Please submit your AI commitment !TODO!</Typography>
                <TextField inputRef={textarea}
                    id={"renai-commitment-content"}
                    label="Comittment"
                    multiline
                    rows={4}
                    defaultValue=""
                    variant="outlined"
                    fullWidth
                    error={!!error}
                    defaultValue={commitment}
                    helperText={error}
                /></> : <Typography variant="body1">
                    <IconButton aria-label="edit" onClick={() => setEditing(true)} ><Edit /></IconButton>
                    {commitment}
            </Typography>}
        </DialogContent>
        <DialogActions>
            {editing && <Button onClick={handleSubmit} color="primary">Submit</Button>}
            <Button onClick={onClose} color="default">{!editing ? 'Ok' : 'Cancel'}</Button>
        </DialogActions>
    </Dialog>;
}

export default RenaiEventCommitment;